import { render } from "./Settings.vue?vue&type=template&id=47aa12d3&scoped=true&ts=true"
import script from "./Settings.vue?vue&type=script&setup=true&lang=ts"
export * from "./Settings.vue?vue&type=script&setup=true&lang=ts"

import "./Settings.vue?vue&type=style&index=0&id=47aa12d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47aa12d3"],['__file',"src/components/Settings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47aa12d3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47aa12d3', __exports__)) {
    api.reload('47aa12d3', __exports__)
  }
  
  module.hot.accept("./Settings.vue?vue&type=template&id=47aa12d3&scoped=true&ts=true", () => {
    api.rerender('47aa12d3', render)
  })

}


export default __exports__